var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "prop-types", "../../UI/Icon/IconSvg", "./Bullets.css"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("prop-types"), require("../../UI/Icon/IconSvg"), require("./Bullets.css"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.IconSvg, global.Bullets);
    global.Bullets = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _propTypes, _IconSvg, _Bullets) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _react = _interopRequireDefault(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _IconSvg = _interopRequireDefault(_IconSvg);

  var Bullets = function Bullets(_ref) {
    var autoplay = _ref.autoplay,
        labels = _ref.labels,
        onBulletClick = _ref.onBulletClick,
        onBulletNavigate = _ref.onBulletNavigate,
        onBulletPress = _ref.onBulletPress,
        pause = _ref.pause,
        slideIndex = _ref.slideIndex,
        teasers = _ref.teasers,
        togglePlayButton = _ref.togglePlayButton;
    return /*#__PURE__*/_react.default.createElement(_Bullets.StyledList, null, /*#__PURE__*/_react.default.createElement(_Bullets.StyledItem, {
      firstOrder: true
    }, /*#__PURE__*/_react.default.createElement(_Bullets.StyledPlay, {
      "aria-label": autoplay ? labels.pause : labels.play,
      onMouseDown: togglePlayButton,
      onKeyPress: togglePlayButton,
      type: "button",
      onFocus: pause
    }, /*#__PURE__*/_react.default.createElement(_IconSvg.default, {
      color: "white",
      name: autoplay ? 'arte-pause--rgaa' : 'arte-play--rgaa',
      size: {
        default: 'xxsmall',
        large: 'xsmall'
      },
      tone: "denseAlpha"
    }))), teasers.map(function (teaserProps, teaserIndex) {
      return /*#__PURE__*/_react.default.createElement(_Bullets.StyledItem, {
        key: "bullet-".concat(teaserIndex)
      }, /*#__PURE__*/_react.default.createElement(_Bullets.StyledButton, {
        "aria-label": teaserIndex === slideIndex ? "".concat(labels.display, " ").concat(teaserProps.title, " - ").concat(labels.active) : " ".concat(labels.display, " ").concat(teaserProps.title),
        isActive: teaserIndex === slideIndex,
        onMouseUp: function onMouseUp() {
          return onBulletClick(teaserIndex);
        },
        onKeyPress: function onKeyPress() {
          return onBulletPress(teaserIndex);
        },
        onKeyUp: function onKeyUp() {
          return onBulletNavigate(teaserIndex);
        },
        onFocus: pause
      }, teaserIndex));
    }));
  };

  Bullets.propTypes = {
    autoplay: _propTypes.default.bool.isRequired,
    labels: _propTypes.default.shape({
      active: _propTypes.default.string,
      display: _propTypes.default.string,
      pause: _propTypes.default.string,
      play: _propTypes.default.string
    }).isRequired,
    onBulletClick: _propTypes.default.func.isRequired,
    onBulletNavigate: _propTypes.default.func.isRequired,
    onBulletPress: _propTypes.default.func.isRequired,
    pause: _propTypes.default.func.isRequired,
    slideIndex: _propTypes.default.number.isRequired,
    teasers: _propTypes.default.arrayOf(_propTypes.default.shape()).isRequired,
    togglePlayButton: _propTypes.default.func.isRequired
  };
  Bullets.defaultProps = {
    onBulletClick: function onBulletClick() {},
    onBulletNavigate: function onBulletNavigate() {},
    onBulletPress: function onBulletPress() {},
    pause: function pause() {}
  };
  var _default = Bullets;
  _exports.default = _default;
});